import React from "react";
import {Control} from "react-hook-form/dist/types";
import {Controller, FieldPath} from "react-hook-form";
import ComboBox from "./ComboBox";
import {CausaleWFRecord} from "@commons/mapping/CausaleWFRecord";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import {CausaliWFParams} from "@commons/services/presenze_api/workflow.api";
import {useCustomCausaliWF} from "@commons/services/presenze_api/workflow.queries";

interface Props<T extends FieldValues> {
    apiParams: CausaliWFParams | null,
    label: string,
    control: Control<T>,
    name: FieldPath<T>,
    defaultValue?: any,
    onChange?: (v: CausaleWFRecord | null) => void,
    auxFilter?: (v: CausaleWFRecord) => boolean,
    disabled?: boolean,
    rules?: Omit<RegisterOptions<T>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>,
    inlineLabel?: boolean,
    labelClassName?: string,
    comboClassName?: string,
}

export function ComboBoxCausaliHR<T extends FieldValues>(props: Props<T>) {
    const {
        apiParams,
        label,
        control,
        name,
        defaultValue,
        onChange,
        auxFilter = (v: CausaleWFRecord) => true,
        disabled,
        rules = {},
        inlineLabel,
        labelClassName = '',
        comboClassName = '',
    } = props;
    const {data, isLoading} = useCustomCausaliWF(apiParams);
    const filteredData = data ? data.filter(auxFilter) : undefined;
    const onChangeCausale = onChange ? onChange : (v: CausaleWFRecord | null) => {
    };
    return <Controller name={name}
                       control={control}
                       defaultValue={defaultValue}
                       rules={rules}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox label={label} value={{codice: value}} disabled={disabled}
                                         inlineLabel={inlineLabel}
                                         onChange={(v) => {
                                             onChange(v?.codice)
                                             onChangeCausale(v);
                                         }} fieldState={fieldState}
                                         data={filteredData}
                                         isLoading={isLoading}
                                         searchablePropsName={['codice', 'descrizione']}
                                         isSameFn={(a, z) => (a && z) ? a.codice === z.codice : false}
                                         keyValueFn={(v) => v.codice!}
                                         displayValueFn={(v) => filteredData && v ? v.descrizione! + ' [#' + v.codice + ')' : ''}
                                         labelClassName={labelClassName}
                                         className={comboClassName}
                               />
                           )
                       }}
    />
}

export default ComboBoxCausaliHR;